export const AGREEMENTS_REDUCER_NAME = 'agreements'
